/*
Lalitha 12/28/2022 3075154998 Add new Component SelectField
Sohel 01/09/2023 3075154998 removed handleNext props
Sohel 01/09/2023 2698959212 pass Type in Selected fields
dilip 01/13/2023 2698959212 Fixed Mapped Selected Fields
dilip 01/16/2023 2698959212 Added handleDirty functionality
dilip 01/16/2023 2698959212 Added GET data API call after map fields save.
sai krishna 01/16/2023 2698959212 add code and description ,type
Sohel 01/16/2023 2698959212 Fixed Download Configuration Toast issue
 dilip 01/20/2023 2698959212 Added Last Step functionality
 Ashraf 01/31/2023 2698959212 Added Sort fields
 Ravi 01/31/2023 2698959212 fixed unsaved popup issue
 Ashraf 02/06/2023 2698959212 fixed sort fields duplicate issue
Sohel 02/07/2023 2698959212 fixed fieldType populate issue
Raghu 02/23/2023 2698959212 fixed new Ui changes
Akhila 06/12/2023 2698959212 added role access
Ravi 06/19/2023 2698959212 Added Breadcrum in data cal and map fields
Sohel 06/19/2023 3075154998 Enable Save Button
Ravi 06/19/2023 2698959212 Added Breadcrum in popup
Ravi 06/23/2023 2698959212 fixed submit issue
Ravi 07/19/2023 2698959212 hide print subtotal from table in Export Manager
*/
import React, { useState, useEffect, useRef } from 'react';
import { Button, Tooltip } from '@material-ui/core';
import reusableInputStyles from '../../../../../components/InputStyles';
import SearchFields from '../../../GlobalFields/DataRepositories/SearchDataRepositories/index';
import SelectSortFields from './SelectSortFields/index';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import DialogBox from './../../../../../components/DialogBox/index';
import DMSelectFieldsTable from './DMSelectFieldsTable';
import { useSelector, useDispatch } from 'react-redux';
import PageLoader from '../../../../../components/PageLoader';
import AddIcon from '@material-ui/icons/Add';
import { ErrorSnackbar, SuccessSnackbar } from '../../../../../components/CustomSnackBar';
import {
  fetchSelectedFieldsData,
  postSelectField,
  resetMsgAndStatus,
  resetBasicInfo,
} from '../../../../../redux/reducers/DataManager';
import BreadCrums from '../../../../../util/BreadCrum';
import EditableDataTable from '../../../Reports/AddReport/Components/EditableDataTable';
import { submissionStart } from '../../../../../redux/reducers/CommonActions/commonActions';

const DMFieldSelect = ({
  handleBack,
  handleNext,
  exportManager,
  handleDirty,
  editExisting,
  DataManagerAccess,
}) => {
  const classes = reusableInputStyles();
  const [open, setOpen] = useState(false);
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const deletedSelectedFields = useRef([]);
  const [sortFiledsDialog, setSortFieldListDialog] = useState(false);
  const [sortFields, setSortFields] = useState([]);
  const [allSortFields, setAllSortFields] = useState([]);
  const [resetSortFields, setSortFieldsReset] = useState(false);
  const reportFieldsDeleteIdsRef = useRef([]);

  const sortFieldsDeleteIdsRef = useRef([]);

  const saveRef = useRef(false);
  const dispatch = useDispatch();
  const {
    isSelectFieldLoading,
    SelectFieldSuccessMsg,
    SelectFieldErrorMsg,
    SelectFieldStatus,
    dmCode,
    selectedProcessorFields,
    basicInfoData,
    basicInfoSuccessMsg,
    isBasicInfoLoading,
    basicInfoErrorMsg,
    dataManagerId,
  } = useSelector(({ dataManagerGroup }) => dataManagerGroup);
  const { enabledSubmission } = useSelector(({ commonActions }) => commonActions);

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
      }, 1500);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg]);

  const type = exportManager ? 'Export' : 'Import';
  const handleSubmit = () => {
    if (dmCode) {
      dispatch(submissionStart());
      const selectedProcessorFields =
        selectedRows?.length > 0
          ? selectedRows?.map((el) => {
            return {
              category: el?.category,
              fieldName: el?.fieldName,
              fieldType:
                  el?.type === 'Record' || el?.type === 'Record Group'
                    ? el?.fieldType
                    : el?.processorFieldType,
              dataManagerCode: dmCode,
              dataManagerRecordId: el?.dataManagerRecordId ? el?.dataManagerRecordId : 0,
              repositoryName: el?.repositoryName,
              dataType: el?.dataType,
              dataRepoId: el?.dataRepositoryId
                ? el?.dataRepositoryId
                : el?.dataRepoId
                  ? el?.dataRepoId
                  : 0,
              dataRepoFieldId: el?.repositoryFieldId
                ? el?.repositoryFieldId
                : el?.dataRepoFieldId
                  ? el?.dataRepoFieldId
                  : 0,
            };
          })
          : [];

      const sortedFields = sortFields?.map((each, i) => {
        return {
          dataManagerSortFieldsId: each?.dataManagerSortFieldsId
            ? each?.dataManagerSortFieldsId
            : 0,
          descending: each.sortOrder,
          fieldCode: each?.fieldName,
          fieldType: each.fieldType,
          repositoryName: each.repositoryName,
          seqNum: i + 1,
          subtotal: each?.printTotal,
        };
      });
      const payload = {
        deleteDmRecordFieldIds: [...new Set(deletedSelectedFields.current)],
        deleteDmSortFieldIds: [...new Set(sortFieldsDeleteIdsRef.current)],
        dataManagerSelectedFieldRequest: selectedProcessorFields,
        dataManagerCode: dmCode,
        tabType: type,
        lastStep: saveRef.current ? 2 : 3,
        dataManagerSortedFieldsRequest: sortedFields,
        dmId: basicInfoData?.dataManagerId ? basicInfoData?.dataManagerId : 0,
      };
      dispatch(postSelectField(payload));
    }
  };

  const handleSortFieldDialog = () => {
    setSortFieldListDialog(false);
  };

  useEffect(() => {
    if (SelectFieldErrorMsg || SelectFieldSuccessMsg) {
      setTimeout(() => {
        if (SelectFieldSuccessMsg && SelectFieldStatus === 200 && !saveRef.current) {
          handleNext && handleNext();
        }
        dispatch(resetMsgAndStatus());
      }, 1500);
    }
  }, [SelectFieldErrorMsg, SelectFieldSuccessMsg]);

  useEffect(() => dispatch(resetMsgAndStatus()), []);
  useEffect(() => {
    if (basicInfoData?.dataManagerId) {
      dispatch(fetchSelectedFieldsData(basicInfoData?.dataManagerId, type));
    }
  }, [basicInfoData?.dataManagerId]);

  useEffect(() => {
    if (basicInfoData?.dataManagerId && SelectFieldStatus === 200 && saveRef.current) {
      dispatch(fetchSelectedFieldsData(dataManagerId, type));
    }
  }, [SelectFieldStatus]);
  useEffect(() => {
    const rows = [];
    selectedProcessorFields?.dMSortFieldList?.map((i) => {
      rows?.push({
        ...i,
        fieldName: i?.fieldCode,
        sortOrder: i?.descending,
        printTotal: i?.subtotal,
        tableData: { tableData: i?.tableData, checked: true },
      });
    });
    setSortFields(rows);
  }, [selectedProcessorFields?.dMSortFieldList]);
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);

  useEffect(() => {
    // if (true) {
    const r = selectedRows?.map((i) => {
      const fields = sortFields?.map((ele) => ele?.repositoryName + ele?.fieldName);
      if (fields?.includes(i?.repositoryName + i?.fieldName)) {
        return {
          ...i,
          tableData: { ...i.tableData, checked: true },
        };
      }
      return {
        ...i,
        tableData: { ...i.tableData, checked: false },
      };
    });
    setAllSortFields(r);
  }, [selectedRows, resetSortFields]);

  useEffect(() => {
    if (selectedProcessorFields?.dMRecordEntityList?.length > 0) {
      const fields = selectedProcessorFields?.dMRecordEntityList?.map((el) => {
        return {
          category: el?.category,
          fieldName: el?.fieldName,
          fieldType: el?.fieldType,
          isActive: el?.isActive,
          dataManagerCode: dmCode,
          dataManagerRecordId: el?.dataManagerRecordId ? el?.dataManagerRecordId : 0,
          repositoryName: el?.repositoryName,
          dataType: el?.dataType,
          type: el?.type,
          processorFieldType: el?.fieldType,
          dataRepoFieldId: el?.dataRepoFieldId ? el?.dataRepoFieldId : 0,
          dataRepoId: el?.dataRepoId ? el?.dataRepoId : 0,
        };
      });

      // Remove duplicate fields
      const uniqueArray = fields.filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            (t) => t.repositoryName === value.repositoryName && t.fieldName === value.fieldName,
          ),
      );

      setSelectedRows(uniqueArray);
    }
  }, [selectedProcessorFields?.dMRecordEntityList]);
  return (
    <>
      <div>
        <BreadCrums
          name={exportManager ? 'Export Manager Name' : 'Import Manager Name'}
          code={basicInfoData?.dmCode}
          description={exportManager ? 'Export Manager Description' : 'Import Manager Description'}
          descriptionValue={basicInfoData?.dmDescription}
          returnType={'Type'}
          returnTypeValue={basicInfoData?.dmType || ''}
        />
      </div>
      <div className="table-header table-card-header justify-content-end new-standard-textfields">
        <Button
          variant="outlined"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => setOpen(true)}
          startIcon={<AccountTreeIcon />}
        >
          Map Fields
        </Button>
      </div>
      <DMSelectFieldsTable
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        deletedSelectedFields={deletedSelectedFields}
        exportManager={exportManager}
        handleDirty={handleDirty}
        DataManagerAccess={DataManagerAccess}
        editExisting={editExisting}
      />
      <DialogBox
        open={open}
        dialogClose={handleClose}
        // title="Search Repository Fields"
        title={
          <div className="dialog-breadcrum">
            <p className="dialoge-title-breadcrum">
              <b>Search Repository Fields</b>
            </p>
            <BreadCrums
              name={'Export Manager Name'}
              code={basicInfoData?.dmCode}
              description={'Export Manager Description'}
              descriptionValue={basicInfoData?.dmDescription}
            />
          </div>
        }
        maxWidth="xl"
      >
        <SearchFields
          setSelectedRows={setSelectedRows}
          selectedRows={selectedRows}
          setTempSelectedRows={setTempSelectedRows}
          tempSelectedRows={tempSelectedRows}
          moduleName={exportManager ? 'EXPORT' : 'IMPORT'}
          isReports={true}
          mapFields={true}
          isDMTrue={true}
          handleClose={handleClose}
          deletedSelectedFields={deletedSelectedFields}
          dmRecordCategory={{
            categoryCode: 'CO',
            categoryName: 'Core',
          }}
          handleDirty={handleDirty}
        />
      </DialogBox>
      {exportManager && (
        <>
          <div className="table-header table-card-header justify-content-end mt-3 new-standard-textfields">
            <Button
              variant="outlined"
              className={`search-btn ${classes.buttonRoot} ml-2`}
              onClick={() => {
                // const copyArr = [...sortFields];
                // copyArr.push(dataObj);
                // setSortFields(copyArr);
                setSortFieldListDialog(true);
              }}
              startIcon={<AddIcon />}
            >
              Sort Fields
            </Button>
          </div>
          <EditableDataTable
            selectedRows={selectedRows}
            sortFields={sortFields}
            sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
            setSortFields={setSortFields}
            editExisting={editExisting}
            DataManagerAccess={DataManagerAccess}
            type={type}
          />
          <DialogBox
            hideBackdrop={true}
            open={sortFiledsDialog}
            dialogClose={handleSortFieldDialog}
            // title="Select Fields"
            title={
              <div className="dialog-breadcrum">
                <p className="dialoge-title-breadcrum">
                  <b>Select Fields</b>
                </p>
                <BreadCrums
                  name={'Export Manager Name'}
                  code={basicInfoData?.dmCode}
                  description={'Export Manager Description'}
                  descriptionValue={basicInfoData?.dmDescription}
                />
              </div>
            }
            maxWidth="xl"
          >
            <SelectSortFields
              sortFields={sortFields}
              setSortFields={setSortFields}
              isReports={true}
              reportFieldsDeleteIdsRef={reportFieldsDeleteIdsRef}
              sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
              tempSelectedRows={tempSelectedRows}
              handleClose={handleSortFieldDialog}
              setSortFieldsReset={setSortFieldsReset}
              handleDirty={handleDirty}
              mapFields={true}
              allSortFields={allSortFields}
              setTempSelectedRows={setTempSelectedRows}
              setAllSortFields={setAllSortFields}
              resetSortFields={resetSortFields}
            />
          </DialogBox>
        </>
      )}
      <div className="d-flex justify-content-center mt-3 new-standard-textfields">
        <Button
          variant="outlined"
          onClick={() => {
            handleBack();
          }}
          className={`reset-btn mr-1 ${classes.buttonRoot}`}
        >
          Back
        </Button>
        {/* {basicInfoData?.isDraft === "N" && ( */}
        <Tooltip title={selectedRows?.length === 0 ? `Please add at least one Filed` : ''}>
          <span>
            <Button
              variant="outlined"
              type="button"
              className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
              disabled={
                selectedRows?.length === 0 ||
                (editExisting && !DataManagerAccess?.edit) ||
                enabledSubmission
              }
              onClick={() => {
                saveRef.current = true;
                handleDirty && handleDirty(false, 'fixed');
                handleSubmit();
              }}
            >
              Save
            </Button>
          </span>
        </Tooltip>
        {/* )} */}
        <Tooltip title={selectedRows?.length === 0 ? `Please add at least one Filed` : ''}>
          <span>
            <Button
              variant="outlined"
              disabled={
                selectedRows?.length === 0 ||
                (editExisting && !DataManagerAccess?.edit) ||
                enabledSubmission
              }
              onClick={() => {
                saveRef.current = false;
                handleSubmit();
              }}
              className={`search-btn ml-1 ${classes.buttonRoot}`}
            >
              Save & Next
            </Button>
          </span>
        </Tooltip>
      </div>

      {(isSelectFieldLoading || isBasicInfoLoading) && <PageLoader />}
      {(SelectFieldErrorMsg || basicInfoErrorMsg) && (
        <ErrorSnackbar errorMsg={SelectFieldErrorMsg || basicInfoErrorMsg} />
      )}
      {(SelectFieldSuccessMsg || basicInfoSuccessMsg) && (
        <SuccessSnackbar successMsg={SelectFieldSuccessMsg || basicInfoSuccessMsg} />
      )}
    </>
  );
};

export default DMFieldSelect;
